<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">MATERIALI E MANODOPERA</h1>
    </div>

    <!--********** CAMPO DI RICERCA **********-->
    <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-7">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
            <div v-if="!schermoLargo">
                <br>
                <CampoData @valoreCambiato="(data)=>modificaData(data, 'inizio')"
                    :valore=props.dataInizio
                    identificativo="primoContattoData"
                    titolo="Inizio"
                />
            </div>
            <div v-if="!schermoLargo">
                <br>
                <CampoData @valoreCambiato="(data)=>modificaData(data, 'fine')"
                    :valore=props.dataFine
                    identificativo="primoContattoData"
                    titolo="Fine"
                />
            </div>
        </div>
        <div class="column is-2" v-if="schermoLargo">
            <CampoData @valoreCambiato="(data)=>modificaData(data, 'inizio')"
                :valore=props.dataInizio
                identificativo="primoContattoData"
                titolo="Inizio"
            />
        </div>
        <div class="column is-2" v-if="schermoLargo">
            <CampoData @valoreCambiato="(data)=>modificaData(data, 'fine')"
                :valore=props.dataFine
                identificativo="primoContattoData"
                titolo="Fine"
            />
        </div>
    </div>

    <!-- <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-5">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
        </div>
        <div class="column is-2">
            <CampoData @valoreCambiato="(data)=>modificaData(data, 'inizio')"
                :valore=props.dataInizio
                identificativo="primoContattoData"
                titolo="Inizio"/>
        </div>
        <div class="column is-2">
            <CampoData @valoreCambiato="(data)=>modificaData(data, 'fine')"
                :valore=props.dataFine
                identificativo="primoContattoData"
                titolo="Fine"/>
        </div>
    </div> -->

    <div class="blocco-scroll">

        <!--********** TOTALI **********-->
        <div class="columns is-mobile is-centered has-background-light p-5">
            <p> COSTI &nbsp; &nbsp; Materiali: {{ generaStringa(sommaCosti, '0,00', true) }} &nbsp; &nbsp; Ore: {{ sommaOre }} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <a @click="props.lavoro?scaricaXlsxCosti(elencoCostiCompleto(), true):scaricaXlsxCosti(elencoCostiCompleto(), false)" title="Scarica costi in formato Excel" v-if="!props.visioneCompatta && schermoLargo"><i class="fas fa-download"></i></a>
                <br> PREZZI &nbsp; &nbsp;
                Materiali: {{ generaStringa(prezzoMateriali, '0,00', true) }}  &nbsp; &nbsp;
                Manodopera: {{ generaStringa(prezzoManodopera, '0,00', true) }}  &nbsp; &nbsp;
                <br> Totale: {{ generaStringa(prezzoMateriali+prezzoManodopera, '0,00', true) }} &nbsp; &nbsp;
                Incidenza materiali: {{ generaStringa(percentualeMateriali*100, '0,00', true) }} %
            </p>
        </div>

        <!--********** TABELLA COSTI **********-->
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaCosto(-1, null, null)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered">Data</th>
                    <th v-if="props.lavoro==null">Lavoro</th>
                    <!-- Icona per manodopera o materiale -->
                    <th class="has-text-centered" title="Tipologia">M</th>
                    <th class="has-text-centered">Fornitore/Lavoratore</th> <!--Campi distinti visualizzati alternativamente-->
                    <th class="has-text-centered">Documento</th>
                    <th>Descrizione</th>
                    <th class="has-text-centered">Costo/Ore</th>
                    <!-- Flag per lavori extra -->
                    <th class="has-text-centered" title="Note">N</th>
                    <th class="has-text-centered" title="Extra">E</th>
                    <th class="has-text-centered" title="Intervento in garanzia">G</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cc, index) in elencoCosti" :key="leggiInfoDB(cc).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaCosto(leggiInfoDB(cc).id, leggiInfoDB(cc).idLavoro, leggiInfoDB(cc).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(cc).id}}</td>
                    <td>{{dataDaTimestamp(cc.data, 'testo')}}</td>
                    <td v-if="props.lavoro==null"><a @click="emit('elementoSelezionato', {tipo: 'lavoro', idCliente: leggiInfoDB(cc).idCliente, idLavoro: leggiInfoDB(cc).idLavoro})">{{leggiInfoDB(cc).stringaLavoro}}</a></td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="cc.lavoratore ? 'Lavoro' : 'Costo'" />
                    </td>
                    <td>{{cc.lavoratore ? cc.lavoratore : cc.fornitore}}</td>
                    <td>{{cc.documento}}</td>
                    <td>{{cc.descrizione}}</td>
                    <td class="has-text-right">{{cc.costo ? generaStringa(cc.costo, '0,00') : cc.ore}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="cc.note" />
                    </td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="cc.extra ? 'Extra':''" />
                    </td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="cc.garanzia ? 'Intervento in garanzia':''" />
                    </td>
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bCopia(leggiInfoDB(cc).id, leggiInfoDB(cc).idLavoro, leggiInfoDB(cc).idCliente)">
                            <span class="icon" title="Copia"><i class="fas fa-copy"></i></span>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <!--********** MESSAGGIO MODALE **********-->
</template>

<script setup>
    import ComponenteIcona from "./ComponenteIcona.vue";
    import CampoData from "./CampoData.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { aggiungiInfoDB, dbClienti, leggiInfoDB, leggiInfoDBRaw } from "@/code/gestioneDB";
    import { impostazioniGenerali, dataDaTimestamp, mostraInfoSviluppo, generaStringa, copiaTrasporto, scaricaXlsxCosti, schermoLargo, getValorePerOrdinamento } from "../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lavoro: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        dataInizio: {
            type: Object,
            default: null },
        dataFine: {
            type: Object,
            default: null },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    const sommaCosti = ref(0);
    const sommaOre = ref(0);
    const prezzoMateriali = ref(0);
    const prezzoManodopera = ref(0);
    const percentualeMateriali = ref(0);
    const stringaNumeroRecord = ref("");
    const testoRicerca = ref(props.testoDaCercare);

    const elencoCosti = computed(()=>{
        let tempElencoCosti = [];
        if (props.lavoro==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const lv in  dbClienti.value[cl].lavori){
                        for(const cc in  dbClienti.value[cl].lavori[lv].costi){
                            tempElencoCosti.push(dbClienti.value[cl].lavori[lv].costi[cc]);
                        }
                    }
                }
            } else {
                for(const lv in dbClienti.value[props.cliente].lavori){
                    for(const cc in dbClienti.value[props.cliente].lavori[lv].costi){
                        tempElencoCosti.push(dbClienti.value[props.cliente].lavori[lv].costi[cc]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const lv = props.lavoro;
            for(const cc in  dbClienti.value[cl].lavori[lv].costi){
                tempElencoCosti.push(dbClienti.value[cl].lavori[lv].costi[cc]);
            }
        }
        ordinaElencoCosti(tempElencoCosti);
        filtraElencoElementi(tempElencoCosti, props.testoDaCercare, ['fornitore','descrizione','lavoratore','documento']);
        calcolaValoriGlobali(tempElencoCosti);
        limitaElencoElementi(tempElencoCosti);
        return tempElencoCosti;
    });

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function elencoCostiCompleto() {
        // Restituisce l'elenco dei costi filtrato ma non limitato a 100 elementi
        let tempElencoCosti = [];
        if (props.lavoro==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const lv in  dbClienti.value[cl].lavori){
                        for(const cc in  dbClienti.value[cl].lavori[lv].costi){
                            tempElencoCosti.push(dbClienti.value[cl].lavori[lv].costi[cc]);
                        }
                    }
                }
            } else {
                for(const lv in dbClienti.value[props.cliente].lavori){
                    for(const cc in dbClienti.value[props.cliente].lavori[lv].costi){
                        tempElencoCosti.push(dbClienti.value[props.cliente].lavori[lv].costi[cc]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const lv = props.lavoro;
            for(const cc in  dbClienti.value[cl].lavori[lv].costi){
                tempElencoCosti.push(dbClienti.value[cl].lavori[lv].costi[cc]);
            }
        }
        ordinaElencoCosti(tempElencoCosti);
        filtraElencoElementi(tempElencoCosti, props.testoDaCercare, ['fornitore','descrizione','lavoratore','documento']);
        return tempElencoCosti;        
    }

    function bCerca() {
        emit('statoInterfacciaCambiato', {testoRicercaCosti: testoRicerca.value});
        // testoRicerca.value = tempTestoRicerca.value;
    }

    function bSelezionaCosto(idCc, idLv, idCl) {
        let tempIdCl;
        let tempIdLv;
        tempIdCl = props.cliente==null ? idCl : props.cliente;
        tempIdLv = props.lavoro==null ? idLv : props.lavoro;
        emit('elementoSelezionato', {
            tipo: 'costo',
            idCliente: tempIdCl,
            idLavoro: tempIdLv,
            idCosto: idCc
        });
    }

    function bCopia(idCc, idLv, idCl) {
        // Copia il costo selezionato in copiaTrasporto
        // creando una proprietà 'costo' all'interno di copiaTrasporto
        copiaTrasporto.value.costo = dbClienti.value[idCl].lavori[idLv].costi[idCc];
        aggiungiInfoDB(copiaTrasporto.value.costo, leggiInfoDBRaw(dbClienti.value[idCl].lavori[idLv].costi[idCc]));
    }

    function ordinaElencoCosti(elenco) {
        elenco.sort((a, b) => {
            // 1. Estrazione sicura dei millisecondi (gestisce dati Caldi e Freddi)
            // Il fallback a 0 manderà automaticamente gli elementi senza data in fondo alla lista
            const dataA = getValorePerOrdinamento(a, 'data', false) || 0;
            const dataB = getValorePerOrdinamento(b, 'data', false) || 0;

            // 2. Ordinamento primario: per Data (Decrescente, dal più recente al più vecchio)
            if (dataA !== dataB) {
                return dataB - dataA;
            }

            // 3. Ordinamento secondario: a parità di data, 'lavoratore' ha la precedenza
            const haLavoratoreA = !!a.lavoratore;
            const haLavoratoreB = !!b.lavoratore;

            if (haLavoratoreA && !haLavoratoreB) return -1; // 'a' è lavoratore, 'b' no -> 'a' sale
            if (!haLavoratoreA && haLavoratoreB) return 1;  // 'b' è lavoratore, 'a' no -> 'b' sale

            // 4. Se sono identici (entrambi lavoratori o entrambi costi) mantieni l'ordine
            return 0;
        });

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra l'elenco cercando il testo nei campi indicati dall'array di stringhe 'campi'
        // const tempStringaNumeroRecord = elencoEl.length;
        if (props.dataInizio) {
            const inizioMillis = getValorePerOrdinamento(props, 'dataInizio') || 0;
            for (let i=0; i < elencoEl.length; i++) {
                const dataMillis = getValorePerOrdinamento(elencoEl[i], 'data') || 0;
                if (dataMillis < inizioMillis) {
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }
        if (props.dataFine) {
            const fineMillis = getValorePerOrdinamento(props, 'dataFine') || 0;
            for (let i=0; i < elencoEl.length; i++) {
                const dataMillis = getValorePerOrdinamento(elencoEl[i], 'data') || 0;
                if (dataMillis > fineMillis) {
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }

        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        // Ciclo tra gli elementi di elencoTesti
        for (let j=0; j < elencoTesti.length; j++) {
            // if ( testo ) {
            if ( (elencoTesti[j]) && (elencoTesti[j]!="") ) {
                for (let i=0; i < elencoEl.length; i++) {
                    const regexCerca = new RegExp(elencoTesti[j], 'i');
                    let temp = null;
                    let pos = -1;
                    for (const cc in campi) {
                        if (pos == -1) {
                            if ( Array.isArray(campi[cc]) ) {
                                temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                            } else {
                                temp = elencoEl[i][campi[cc]];
                            }
                            pos = String(temp).search(regexCerca);
                        }
                    }
                    if (pos == -1) {
                        pos = String(leggiInfoDB(elencoEl[i]).stringaLavoro).search(regexCerca);
                    }
                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
    }

    function limitaElencoElementi(elencoEl) {
        // Limita l'elencoEl a 100 e crea la stringa con il numero dei reord
        const tempStringaNumeroRecord = elencoEl.length;
        if (elencoEl.length>55 && props.lavoro==null){
            elencoEl.splice(50,(elencoEl.length-50));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    function calcolaValoriGlobali(elencoEl) {
        // Cerca in tutti gli elementi di elencoEl e somma i costi e le ore
        // prima di limitare il numero di record
        let tempCosti = 0;
        let tempOre = 0;
        for (let i=0; i < elencoEl.length; i++) {
            if (elencoEl[i].costo) {
                tempCosti += elencoEl[i].costo;
            } else if(elencoEl[i].ore) {
                tempOre += elencoEl[i].ore;
            }
        }
        sommaCosti.value = tempCosti;
        sommaOre.value = tempOre;
        prezzoManodopera.value = impostazioniGenerali.value.prezzoManodopera * sommaOre.value;
        prezzoMateriali.value = (1+impostazioniGenerali.value.ricaricoGenerale) * sommaCosti.value;
        percentualeMateriali.value = prezzoMateriali.value / (prezzoManodopera.value + prezzoMateriali.value);
    }

    function modificaData(data, tipo) {
        let tempDataInizio = props.dataInizio;
        let tempDataFine = props.dataFine;

        if (tipo=='inizio') {
            tempDataInizio = data;
        } else {
            tempDataFine = data;
        }

        if (tempDataInizio != null && tempDataFine != null) {
            const inizioMillis = getValorePerOrdinamento({ data: tempDataInizio }, 'data') || 0;
            const fineMillis = getValorePerOrdinamento({ data: tempDataFine }, 'data') || 0;
            if (fineMillis < inizioMillis) {
                if (tipo == 'inizio') {
                    tempDataFine = data;
                } else {
                    tempDataInizio = data;
                }
            }
        }

        emit('statoInterfacciaCambiato', {dataInizioRicercaCosti: tempDataInizio, dataFineRicercaCosti: tempDataFine});
    }

</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>